module.exports = __webpack_public_path__ + "3359b4bf.png";